import Option from '../utils/filters/Option'

export const DEFAULT_ACTIVITY_TYPE = 2
export const DEFAULT_CONTRACT_TYPE = 9897267

export const capitalizeWords = (str: string) =>
    str
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')

export const getDealerInfoOption = (option: any) =>
    `${option.company} - ${option.address}${
        option.streetNumber ? ' ' + option.streetNumber : ''
    }, ${option.city}`

export const getDealerAddress = (option: any) =>
    `${option.address}${
        option.streetNumber ? ' ' + option.streetNumber : ''
    }, ${option.city}`

export function sortOptionsAlphabetically(options: Option): Option {
    return Object.entries(options)
        .sort(([, labelA], [, labelB]) =>
            labelA.localeCompare(labelB, undefined, {sensitivity: 'base'})
        )
        .reduce<Option>((acc, [key, label]) => {
            acc[key] = label // eslint-disable-line security/detect-object-injection

            return acc
        }, {})
}

export function isPngSrcImage(src: string): boolean {
    if (!src) {
        return false
    }
    if (src.startsWith('data:image/')) {
        return src.toLowerCase().startsWith('data:image/png')
    }
    const path = src.split('?')[0].split('#')[0]

    return /\.png$/i.test(path)
}

export const isMobile = window.innerWidth <= 768
